// Newsletter subscribe enhancer for the "Weekly insight" section.
//
// 1. Submits the native Shopify customer form via fetch so the page does NOT
//    reload. The email is still stored in Shopify (dual capture).
// 2. Best-effort mirrors the signup to Substack. Substack has no public
//    subscribe API and blocks cross-origin reads, so the direct call is
//    fire-and-forget. For confirmable delivery, set a proxy URL
//    (data-cm-substack-proxy) that forwards the email to Substack server-side.
//
// Progressive enhancement: with JS disabled the form posts natively and the
// server renders the success/error message after a reload.
(function () {
  // Reduce whatever the merchant pasted into the "publication URL" setting to a
  // clean origin. They often paste the whole <iframe> embed snippet (sometimes
  // with curly quotes), e.g. https://x.substack.com/embed?transparent=1” width=“480">.
  // Grab the first URL token and keep only its origin so /api/v1/free is valid.
  function substackOrigin(raw) {
    var s = (raw || '').trim();
    if (!s) return '';
    var m = s.match(/https?:\/\/[^\s"'<>“”]+/);
    if (m) s = m[0];
    else if (!/^https?:\/\//i.test(s)) s = 'https://' + s.split(/[\s"'<>“”]/)[0];
    try {
      return new URL(s).origin;
    } catch (e) {
      return '';
    }
  }

  function sendToSubstack(form, email) {
    var proxy = (form.dataset.cmSubstackProxy || '').trim();
    var pub = substackOrigin(form.dataset.cmSubstackUrl);

    try {
      if (proxy) {
        // User-hosted proxy talks to Substack server-side; JSON is fine here.
        fetch(proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, publication: pub }),
          keepalive: true,
        }).catch(function () {});
      } else if (pub) {
        // Direct, best-effort. Form-encoded keeps it a CORS "simple" request
        // (no preflight); no-cors means the response is opaque/unreadable.
        var body = new URLSearchParams({
          email: email,
          first_url: location.href,
          current_url: location.href,
          source: 'embed',
        }).toString();
        fetch(pub + '/api/v1/free', {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body,
          keepalive: true,
        }).catch(function () {});
      }
    } catch (e) {
      // Never let a Substack error block the Shopify submit.
    }
  }

  function messageEl(form) {
    var el = form.querySelector('.cm-weekly__message');
    if (!el) {
      el = document.createElement('p');
      el.className = 'cm-weekly__message';
      form.appendChild(el);
    }
    return el;
  }

  function showMessage(form, text, isError) {
    var el = messageEl(form);
    el.textContent = text;
    el.classList.toggle('cm-weekly__message--error', !!isError);
    el.classList.toggle('cm-weekly__message--success', !isError);
    el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  // Shopify re-renders this section with .cm-weekly__message--error when the
  // submit fails (the flash survives the post-redirect-get). Scope the lookup
  // to this section's class so unrelated page errors don't trigger a false fail.
  function parseError(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var err = doc.querySelector('.cm-weekly__message--error');
      return err ? err.textContent.trim() : '';
    } catch (e) {
      return '';
    }
  }

  function submitToShopify(form) {
    // form.action resolves to whatever the native submit would post to, so we
    // don't hardcode the customer endpoint. Same-origin POST → no CORS.
    return fetch(form.action, { method: 'POST', body: new FormData(form) }).then(function (res) {
      return res.text().then(function (html) {
        var err = parseError(html);
        if (err) return { ok: false, error: err };
        if (!res.ok) return { ok: false };
        return { ok: true };
      });
    });
  }

  function bind(form) {
    if (form.dataset.cmSubstackBound) return;
    form.dataset.cmSubstackBound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      var input = form.querySelector('input[type="email"], input[name="contact[email]"]');
      var email = input && input.value.trim();
      if (!email) return;

      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      form.setAttribute('aria-busy', 'true');

      sendToSubstack(form, email);

      submitToShopify(form)
        .then(function (result) {
          if (result.ok) {
            showMessage(form, form.dataset.cmSuccess || 'Thanks for subscribing!', false);
            if (input) input.value = '';
          } else {
            showMessage(form, result.error || 'Something went wrong. Please try again.', true);
          }
        })
        .catch(function () {
          showMessage(form, 'Something went wrong. Please try again.', true);
        })
        .then(function () {
          if (btn) btn.disabled = false;
          form.removeAttribute('aria-busy');
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-cm-substack-url], form[data-cm-substack-proxy]').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-bind when a section re-renders in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
